<template>
  <page :title="i18n.title">
    <div class="confirm-warp">
      <div class="vcard flex-s pay-amount">
      <div class="pay-amount-title">{{ i18nPay.payamount }}</div>
      <div style="color: #00AB46;" class="flex-c">
        <span class="doller">{{ currency }}</span>
        <span class="pay-price">{{ price }}</span>
      </div>
    </div>
    <div class="pay-h1 ">{{ i18nPay.choosepaymethod }}</div>
      <!-- <div class="confirm-info">
        <div class="confirm-title">{{ i18n.pay_label }}</div>
        <div class="confirm-price">{{ currency }}{{ payMode === 'creditcard' ? cabinet.yajin : price }}</div>
        <div class="confirm-icon">
          <img src="../../assets/imgs/icon_tips.png" />
          <span>{{ payType === 'YJ' ? i18n.auth_tips.format(currency, price) : i18n.price_tips }}</span>
        </div>
      </div>
      <div class="confirm-payment-label">
        <span>{{ i18n.pay_type }}</span>
      </div> -->
      <div class="confirm-payment">
        <!-- <div class="confirm-payment-item" @click="payMode='paypal'">
          <div class="confirm-payment-item-info">
            <img src="../../assets/imgs/icon_paypal.png" />
            <div class="content">
              <div class="title">Paypal</div>
            </div>
          </div>
          <div class="confirm-payment-item-checked">
            <img v-if="payMode==='paypal'" src="../../assets/imgs/checkbox_selected.png" />
            <img v-else src="../../assets/imgs/checkbox.png" />
          </div>
        </div> -->
        <!-- <div v-if="system === 'ios'" class="confirm-payment-item" @click="payMode = 'applepay'">
          <div class="confirm-payment-item-info">
            <img src="../../assets/imgs/icon_applepay.png" />
            <div class="content">
              <div class="title">Apple Pay</div>
            </div>
          </div>
          <div class="confirm-payment-item-checked">
            <img v-if="payMode === 'applepay'" src="../../assets/imgs/checkbox_selected.png" />
            <img v-else src="../../assets/imgs/checkbox.png" />
          </div>
        </div>
        <div v-if="system === 'android'" class="confirm-payment-item" @click="payMode = 'googlepay'">
          <div class="confirm-payment-item-info">
            <img src="../../assets/imgs/icon_googlepay.png" />
            <div class="content">
              <div class="title">Google Pay</div>
            </div>
          </div>
          <div class="confirm-payment-item-checked">
            <img v-if="payMode === 'googlepay'" src="../../assets/imgs/checkbox_selected.png" />
            <img v-else src="../../assets/imgs/checkbox.png" />
          </div>
        </div>
        <div v-if="payType === 'YJ'" class="confirm-payment-item" @click="payMode = 'creditcard'">
          <div class="confirm-payment-item-info">
            <img src="../../assets/imgs/icon_creditcard.png" />
            <div class="content">
              <div class="title">Credit Card</div>
            </div>
          </div>
          <div class="confirm-payment-item-checked">
            <img v-if="payMode === 'creditcard'" src="../../assets/imgs/checkbox_selected.png" />
            <img v-else src="../../assets/imgs/checkbox.png" />
          </div>
        </div>
        <div class="confirm-payment-item" @click="payMode = 'debitcard'">
          <div class="confirm-payment-item-info">
            <img src="../../assets/imgs/icon_creditcard.png" />
            <div class="content">
              <div class="title">Debit Card</div>
            </div>
          </div>
          <div class="confirm-payment-item-checked">
            <img v-if="payMode === 'debitcard'" src="../../assets/imgs/checkbox_selected.png" />
            <img v-else src="../../assets/imgs/checkbox.png" />
          </div>
        </div> -->
        <template v-for="item in payModeList">
          <div v-if="(item.phone === 'all' || item.phone === system || item.phone === browser || (item.phone === 'phone' && system !== ''))" :key="item.pId" class="confirm-payment-item" @click="onPayMode(item)">
            <div class="confirm-payment-item-info">
              <img :src="(item.pPaymentType === 'GOOGLE_PAY' || item.pPaymentType === 'STRIPE_GOOGLE') ? require('../../assets/imgs/icon_googlepay.png') : (item.pPaymentType === 'APPLE_PAY' || item.pPaymentType === 'STRIPE_APPLE') ? require('../../assets/imgs/icon_applepay.png') : require('../../assets/imgs/icon_creditcard.png')" />
              <div class="content">
                <div class="title">{{item.label}}</div>
              </div>
            </div>
            <div class="confirm-payment-item-checked">
              <img v-if="payMode === item.pPaymentType && item.currencySymbol === currencySymbol" src="../../assets/imgs/checkbox_selected.png" />
              <img v-else src="../../assets/imgs/checkbox.png" />
            </div>
          </div>
        </template>
      </div>
      <div class="confirm-btns">
        <div class="btn" @click="onPay" :disabled="disabled">{{ i18n.submit }}</div>
      </div>
      <popup-warp v-model="isCreditcard">
        <div>
          <div class="creditcard-input">
            <div id="credit-card-element"></div>
          </div>
          <div class="btn creditcard-btn" @click="onStripeSetup">立即付款</div>
        </div>
      </popup-warp>
      <popup-warp v-model="isDebitcard">
        <div>
          <div class="creditcard-input">
            <div id="debit-card-element"></div>
          </div>
          <div class="btn creditcard-btn" @click="onStripePay">立即付款</div>
        </div>
      </popup-warp>
      <popup-warp v-model="mpesaPhoneShow">
        <div class="confirm-row">
          <div class="area" @click="isAreaView = true">
            <span>+{{areaCode}}</span>
            <div class="area-down"></div>
          </div>
          <input type="number" v-model="phone" :placeholder="$t('login.phone_number')">
        </div>
        <div class="btn creditcard-btn" @click="onSMSPay">立即付款</div>
      </popup-warp>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
  </page>
</template>

<script>
import { SelectArea } from '../../components/select'
import { mapState } from 'vuex'
import { getToken } from '../../utils/stripe_pay.js'
import { STRIPE_PREPAY_SPTOKEN, STRIPE_PAYORDER_SPTOKEN, PAYPAL_PRE_PAY, PAYPAL_RECHARGE,
  STRIPE_PAY_OF_CONFIRM, STRIPE_RECHARGE_OF_CONFIRM, STRIPE_PAY_CONFIRM,
  STRIPE_PREAUTH_OF_CONFIRM, STRIPE_PREAUTH_AUTO_CONFIRM, PAYMODE, WECHAT_MP_PRE_PAY,
  STRIPE_PAYORDER, STRIPE_RECHARGE_WALLET, STRIPE_BALANCERENT, MPESA_DEPOSIT_RENT,
  MPESA_RECHARGE, MPESA_PAYORDER, MPESA_PAYCONFIRM } from '../../apis/payment'
import stripeMixin from '../../mixins/stripe'
import { PopupWarp } from '../../components/popup'
export default {
  mixins: [stripeMixin],
  components: {
    PopupWarp,
    SelectArea
  },
  computed: {
    ...mapState(['system', 'browser', 'cabinet', 'user', 'qrcode', 'wallet']),
    i18n () {
      return this.$t('confirm')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nPay () {
      return this.$t('paymethod')
    },
    currency () {
      if (this.cabinet) {
        return this.cabinet.currencyName
      } else {
        return this.user.pcurrencyName
      }
    }
  },
  watch: {
    payMode (val, oldVal) {
      console.log('payMode', val)
      if (val === 'APPLE_PAY' || val === 'STRIPE_APPLE' || val === 'STRIPE_GOOGLE' || val === 'GOOGLE_PAY') {
        if (!this.stripePayRequest) {
          this.disabled = true
          this.$loading(true)
          this.getStripeToken()
        } else {
          this.disabled = false
        }
      } else {
        this.disabled = false
      }
    },
    stripePayRequest (val, oldVal) {
      this.disabled = !val
    }
  },
  data () {
    return {
      areaCode: '86',
      price: 0,
      payType: 'YJ',
      formId: '',
      cabinetID: '',
      yaJinType: null,
      pdailiId: '',
      payMode: 'STRIPE_CARD',
      pId: '', // 代理或平台支付配置id
      currencySymbol: '$',
      country: 'US', // 国家
      currencyname: 'usd', // 货币类型
      publicKey: '', // 支付通道的公钥
      disabled: false,
      stripePayRequest: null,
      isCreditcard: false,
      cardStyle: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      },
      creditcard: null,
      clientSecret: null,
      debitOrder: null,
      isDebitcard: false,
      mpesaPhoneShow: false,
      isAreaView: false,
      debitcard: null,
      payModeList: [],
      orderId: '',
      phone: ''
    }
  },
  methods: {
    onSelct (val) {
      this.areaCode = val
    },
    // 支付方式选中
    onPayMode (v) {
      console.log('支付方式===', v)
      this.pId = v.pId
      this.payMode = v.pPaymentType
      this.currencySymbol = v.currencySymbol
      this.currencyname = v.pCurrencyType
      this.publicKey = v.publicKey
      this.country = v.configDetails.accountCountry
    },
    getStripeToken () {
      getToken(this.price, 'MY', this.currencyname.toLowerCase(), this.onStripe)
        .then(data => {
          console.log('stripe getToken', data)
          this.stripePayRequest = data
          this.$loading(false)
        })
        .catch(error => {
          this.stripePayRequest = null
          console.log('stripe getTokenerr', error)
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_support,
            showCancel: false,
            confirmText: this.i18n.msg_fail_confirm
          })
        })
    },
    // apple和Google支付时调用
    onStripe (token, ev) {
      let url = ''
      let datas = {}
      if (this.cabinet && (this.payType === 'YJ' || this.payType === 'mifi')) {
        url = STRIPE_PREPAY_SPTOKEN
        datas = {
          qrcode: this.cabinet.qrcode,
          stripeToken: token, // stripe官方支付的一次性token
          paymentId: this.pId // 代理或平台支付配置id
        }
      } else if (this.price > 0 && this.payType === 'FK') {
        url = STRIPE_PAYORDER_SPTOKEN
        datas = {
          outTradeNo: this.orderId,
          couponNo: null,
          stripeToken: token,
          paymentId: this.pId
        }
      } else {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.error,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.push('/')
        })
      }
      this.$post(
        url,
        datas,
        resp => {
          if (ev && ev.complete) {
            ev.complete('success')
          }
          this.$loading(false)
          console.log(resp)
          if (this.payType === 'CZ') {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.i18nMsg.success_payment,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            }).then(() => {
              this.$router.replace('/mine')
            })
          } else {
            this.$toast(this.i18nMsg.success_payment)
            if (this.payType === 'FK') {
              this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe&payType=FK`)
              return
            }
            this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe`)
          }
        },
        error => {
          if (ev && ev.complete) {
            ev.complete('fail')
          }
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          })
        }
      )
    },
    onPay () {
      if (this.payMode === 'paypal') {
        this.onPaypal()
      } else if (this.payMode === 'APPLE_PAY' || this.payMode === 'STRIPE_APPLE' || this.payMode === 'STRIPE_GOOGLE' || this.payMode === 'GOOGLE_PAY') {
        this.stripePayRequest.show()
      } else if (this.payMode === 'STRIPE_CARD') {
        this.onCreditcard()
      } else if (this.payMode === 'debitcard') {
        this.onDebitcard()
      } else if (this.payMode === 'STRIPE_WECHAT') {
        this.onWechatPay()
      } else if (this.payMode === 'M-PESA') {
        console.log(this.cabinet)
        this.mpesaPhoneShow = true
        if (this.user && this.user.pmobile) {
          this.phone = this.user.pmobile.split(this.user.alUserId)[1]
        }
      } else {
        this.$loading(true)
        setTimeout(() => {
          this.$loading(false)
          this.$router.replace('/result')
        }, 3000)
      }
    },
    onPaypal () {
      this.$loading(true)
      let url = ''
      if (this.payType === 'CZ') {
        url = PAYPAL_RECHARGE
      } else if (this.cabinet) {
        url = `${PAYPAL_PRE_PAY}/${this.cabinet.qrcode}`
      }
      this.$post(
        url,
        {
          amount: this.price
        },
        resp => {
          this.$loading(false)
          if (resp.data) {
            this.$loading(true)
            window.location.href = resp.data
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onPaypal()
          })
          console.log(error)
        }
      )
    },
    onSMSRent () { // 肯尼亚支付通道的
      console.log('肯尼亚支付')
      this.$loading(true)
      this.$get(
        `${MPESA_DEPOSIT_RENT}?qrcode=${this.cabinetID}`,
        {},
        resp => {
          this.$loading(false)
          if (this.payType !== 'YJ') {
            this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=mpesa&payType=${this.payType}`)
            return
          }
          this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=mpesa`)
          console.log(resp)
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    onSMSPay () { // 肯尼亚支付通道的
      console.log('肯尼亚支付')
      if (!this.phone) {
        this.$toast(this.i18nMsg.no_phone)
        return
      }
      let url = ''; let datas = {}
      if (this.payType === 'CZ') {
        url = `${MPESA_RECHARGE}`
        datas = {
          amount: this.price,
          rechargeType: this.cabinetID ? 'deposit' : 'balance',
          paymentId: this.pId,
          phoneNumber: this.areaCode + this.phone
        }
      } else {
        url = `${MPESA_PAYORDER}`
        datas = {
          outTradeNo: this.orderId,
          couponNo: '',
          paymentId: this.pId,
          phoneNumber: this.areaCode + this.phone
        }
      }
      this.$loading(true)
      this.$post(
        url,
        datas,
        resp => {
          this.$loading(false)
          this.mpesaPhoneShow = false
          console.log(resp)
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18n.SMSConfirm,
            confirmText: this.i18nMsg.confirm,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onSMSCheckOrder(resp.data.out_trade_no)
            // if (this.payType === 'CZ' && this.cabinetID) {
            //   this.$router.replace(`/result?tradeNo=${resp.data.out_trade_no}&payMode=mpesa&payType=${this.payType}`)
            //   return
            // }
            // this.$router.replace(`/result?tradeNo=${resp.data.out_trade_no}&payMode=mpesa`)
          })
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        },
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }
      )
    },
    onSMSCheckOrder (tradeNo) {
      this.loading = true
      this.$get(
        `${MPESA_PAYCONFIRM}?outTradeNo=${tradeNo}`,
        {},
        resp => {
          if (resp.data && resp.data.orderStatus !== 0) {
            this.onSMSRent()
          } else {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.$t('result.msg_fail_content'),
              confirmText: this.i18nMsg.confirm,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.onSMSCheckOrder(tradeNo)
            })
          }
        },
        error => {
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.$t('result.msg_fail_content'),
            confirmText: this.i18nMsg.confirm,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onSMSCheckOrder(tradeNo)
          })
          // if (error === '正在请求中') {
          //   setTimeout(() => {
          //     this.onSMSCheckOrder(tradeNo)
          //   }, 1000)
          // } else {
          console.log(error)
          //   this.$toast(error)
          // }
        }
      )
    },
    onCreditcard () {
      let url = ''
      let datas = {}
      if (this.cabinet && this.payType === 'YJ') {
        url = `${STRIPE_PREAUTH_OF_CONFIRM}/${this.cabinet.qrcode}`
        datas = {
          paymentId: this.pId,
          amount: this.price
        }
      } else if (this.price > 0 && this.payType === 'FK') {
        url = STRIPE_PAYORDER
        datas = {
          outTradeNo: this.orderId,
          couponNo: null,
          paymentId: this.pId
        }
      } else {
        url = STRIPE_RECHARGE_WALLET
        datas = {
          amount: this.price,
          paymentId: this.pId
        }
      }
      this.$loading(true)
      this.$post(
        url,
        datas,
        resp => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            if (window.stripeElements) {
              this.clientSecret = resp.data
              this.loadStripeScript(this.publicKey)
              this.creditcard = window.stripeElements.create('card', { style: this.cardStyle })
              this.creditcard.mount('#credit-card-element')
              this.$nextTick(() => {
                this.isCreditcard = true
              })
            } else {
              this.loadStripeScript(this.publicKey)
              this.$toast('loading...')
            }
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            // content: this.i18n.msg_fail_order,
            content: error,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onCreditcard(this.publicKey)
          })
          console.log(error)
        }
      )
    },
    onStripeSetup () {
      const vm = this
      vm.$loading(true)
      if (this.cabinet && (this.payType === 'YJ')) { // 租借
      // paymentIntent通过付款方式确认卡设置
        window.stripe
          .confirmCardPayment(vm.clientSecret.clientSecret, {
            payment_method: {
              card: vm.creditcard,
              billing_details: {
                name: 'test'
              }
            }
          })
          .then(result => {
            console.log(result)
            vm.$loading(false)
            if (result.error) {
              vm.$toast(result.error.message)
            } else {
              vm.confirmSetup(result.paymentIntent.id, result.paymentIntent.payment_method)
            }
          })
      } else { // 订单付款
        // paymentIntent通过付款方式确认卡付款
        window.stripe
          .confirmCardPayment(vm.clientSecret.clientSecret, {
            payment_method: {
              card: vm.creditcard,
              billing_details: {
                name: 'test'
              }
            }
          })
          .then(result => {
            console.log(result)
            vm.$loading(false)
            if (result.error) {
              vm.$toast(result.error.message)
            } else {
              vm.confirmSetup(result.paymentIntent.id, result.paymentIntent.payment_method)
            }
          })
      }
    },
    confirmSetup (id, paymentMethod) {
      this.$loading(true)
      let url = `${STRIPE_PREAUTH_AUTO_CONFIRM}?tradeNo=${id}&orderType=${this.payType === 'YJ' ? 'preAuth' : 'czOrder'}&paymentMethod=${paymentMethod}`
      let datas = {
        outTradeNo: this.clientSecret.outTradeNo
      }
      this.$get(
        url,
        datas,
        resp => {
          this.$loading(false)
          this.isCreditcard = false
          if (this.payType !== 'YJ') {
            this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe&payType=${this.payType}`)
            return
          }
          this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe`)
          console.log(resp)
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    onStripePay () {
      const vm = this
      vm.$loading(true)
      window.stripe.handleCardPayment(vm.debitOrder.clientSecret, vm.debitcard).then(result => {
        console.log('result', result)
        if (result.error) {
          vm.$loading(false)
          vm.$toast(result.error.message)
        } else {
          window.stripe.retrievePaymentIntent(vm.debitOrder.clientSecret).then(result => {
            console.log('init result', result)
            vm.$loading(false)
            if (result.paymentIntent) {
              vm.confirmPay(result.paymentIntent.id)
            }
          })
        }
      })
    },
    confirmPay (id) {
      this.$loading(true)
      this.$post(
        STRIPE_PAY_CONFIRM,
        {
          paymentId: id,
          outTradeNo: this.debitOrder.outTradeNo
        },
        resp => {
          this.$loading(false)
          this.isCreditcard = false
          if (this.payType === 'CZ') {
            this.$router.go(-2)
          } else if (this.cabinet) {
            this.$router.replace(`/result?tradeNo=${resp.data}&payMode=stripe`)
          }
          console.log(resp)
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    onDebitcard () {
      this.$loading(true)
      let url = ''
      if (this.payType === 'CZ') {
        url = STRIPE_RECHARGE_OF_CONFIRM
      } else if (this.cabinet) {
        url = `${STRIPE_PAY_OF_CONFIRM}/${this.cabinet.qrcode}`
      }
      this.$post(
        url,
        {
          amount: this.price
        },
        resp => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            if (window.stripeElements) {
              this.debitOrder = resp.data
              this.loadStripeScript(this.publicKey)
              this.debitcard = window.stripeElements.create('card', { style: this.cardStyle })
              this.debitcard.mount('#debit-card-element')
              this.$nextTick(() => {
                this.isDebitcard = true
              })
            } else {
              this.$toast('loading...')
            }
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onDebitcard(this.publicKey)
          })
          console.log(error)
        }
      )
    },
    onWechatPay () {
      this.$loading(true)
      const vm = this
      this.$post(
        `${WECHAT_MP_PRE_PAY}/${this.cabinet.qrcode}`,
        {
          amount: this.price,
          formId: this.formId || ''
        },
        resp => {
          this.$loading(false)
          console.log('wechat pre pay', resp)
          const data = resp.data
          wx.chooseWXPay({
            timestamp: data.timeStamp,
            nonceStr: data.nonceStr,
            package: data.package,
            signType: data.signType,
            paySign: data.paySign,
            success: function (res) {
              vm.$router.replace(`/result?tradeNo=${data.out_trade_no}&shopid=${this.cabinet.shopid}`)
            },
            fail: function (res) {
              console.log('wxpay fail', res)
              vm.$toast(res.errMsg)
            }
          })
        },
        error => {
          console.log('wechat pre pay error', error)
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    getPayMode () {
      console.log('hahah', this.cabinet, this.wallet)
      let url = this.payType !== 'CZ' ? `${PAYMODE}${`?id=${this.qrcode}`}` : `${PAYMODE}?agentId=${this.wallet ? this.wallet.pdailiId : this.cabinet.userWallet.pdailiId}`
      this.$loading(true)
      this.$get(
        url,
        {},
        resp => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            let list = resp.data
            list.map((v, i, arr) => {
              if (v.pPaymentType === 'STRIPE_CARD') {
                v.label = 'Credit Card'
                v.phone = 'all'
              } else if (v.pPaymentType === 'STRIPE_WECHAT') {
                v.label = 'WeChat'
                v.phone = 'wechat'
              } else if (v.pPaymentType === 'APPLE_PAY' || v.pPaymentType === 'STRIPE_APPLE') {
                v.label = 'Apple Pay'
                v.phone = 'ios'
              } else if (v.pPaymentType === 'GOOGLE_PAY' || v.pPaymentType === 'STRIPE_GOOGLE') {
                v.label = 'Google Pay'
                v.phone = 'android'
              } else if (v.pPaymentType === 'M-PESA') {
                v.label = 'SMS Payment'
                v.phone = 'all'
              }
              // list.push(v)
            })
            this.payModeList = list
            if (list.length > 0) {
              let item = list.filter(v => {
                return v.pPaymentType === 'STRIPE_CARD'
              })
              this.payMode = item.length > 0 ? item[0].pPaymentType : list[0].pPaymentType
              this.currencySymbol = item.length > 0 ? item[0].currencySymbol : list[0].currencySymbol // 货币符号
              this.currencyname = item.length > 0 ? item[0].configDetails.currency : list[0].configDetails.currency // 货币类型
              this.publicKey = item.length > 0 ? item[0].publicKey : list[0].publicKey
              this.pId = item.length > 0 ? item[0].pId : list[0].pId
              this.country = item.length > 0 ? item[0].configDetails.accountCountry : list[0].configDetails.accountCountry
              console.log(this.publicKey, this.payMode)
              if (list[0].pPaymentType !== 'M-PESA') {
                this.loadStripeScript(this.publicKey)
              }
            }
            console.log('list======', list)
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: error,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode()
          })
          console.log(error)
        }
      )
    }
  },
  created () {
    let price = this.$route.query.price
    let formId = this.$route.query.formId
    this.price = price ? Number(price) : 0
    this.orderId = this.$route.query.outTradeNo
    this.formId = formId
    this.payType = this.$route.query.payType
    this.cabinetID = this.$route.query.cabinetID
    this.yaJinType = this.$route.query.yaJinType
    this.getPayMode()
    console.log(this)
  }
}
</script>

<style lang="less">
.noClick {
  opacity: 0.5;
  pointer-events: none;  /* 禁止鼠标点击 */
}
.confirm-warp {
  overflow-y: scroll;
}
.confirm-info {
  background: #ffffff;
  text-align: center;
  padding: 40px;
}
.confirm-title {
  font-size: 36px;
}
.confirm-price {
  font-size: 80px;
  color: #fc0d1b;
}
.confirm-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }
  & span {
    text-align: left;
    font-size: 28px;
    color: #999999;
  }
}
.confirm-payment {
  background: #ffffff;
  padding: 30px;
  &-label {
    padding: 10px 20px;
    font-size: 28px;
    color: #999999;
  }
  &-item {
    display: flex;
    align-items: center;
    padding: 30px 20px;
    border-bottom: 1px solid #dddddd;
    & img {
      width: 40px;
      height: 40px;
    }
    &-info {
      display: flex;
      align-items: center;
      flex: 1;
      & .content {
        padding-left: 10px;
      }
      & .sub_title {
        font-size: 28px;
        color: #fec348;
      }
    }
  }
}
.confirm-remark {
  padding: 0 32px;
}
.confirm-remark .title {
  margin-top: 40px;
  font-size: 32px;
}
.confirm-remark .desc {
  font-size: 28px;
  color: rgba(102, 102, 102, 1);
  font-weight: 400;
  word-break: normal !important;
  white-space: normal !important;
}
.confirm-btns {
  padding: 60px 40px 20px;
}
.confirm-btns .btn {
  margin-top: 20px;
}
/* #ifdef MP-WEIXIN */
.confirm-btns button.btn {
  background-color: #65b74e;
}
/* #endif */
.confirm-checkbox {
  padding: 30px;
  & label {
    display: flex;
    align-items: center;
  }
  & span {
    color: #52ac7a;
  }
}
.btn-paypal {
  background: #fec348 !important;
}
.btn-paypal img {
  width: 277px;
  height: 60px;
  margin: 18px 0;
}
.btn-applepay {
  background: #ffffff !important;
  color: #050608;
}
.btn-applepay img {
  width: 143px;
  height: 60px;
  margin: 18px 0;
}
.btn-googlepay {
  color: #5f6368;
  background: #ffffff !important;
}
.btn-googlepay img {
  width: 145px;
  height: 60px;
  margin: 18px 0;
}
.creditcard-input {
  margin: 48px 48px 200px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #e4e7ed;
}
.creditcard-btn {
  margin: 48px;
}
.confirm-row {
    margin: 36px 45px 140px;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 4px solid rgb(211, 211, 211);
    border-radius: 20px;
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }
    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: black transparent transparent;
    }
    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(to right, rgba(194, 194, 194, 1), rgba(252, 252, 252, 1));
      img {
        width: 180px;
        height: 60px;
      }
    }
  }
  .pay-amount {
  padding: 43px 20px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
  margin-top: 40px;

  .pay-amount-title {
    font-size: 30px;
    font-family: Work Sans-Medium, Work Sans;
    font-weight: 500;
    color: #444444;
  }

  .doller {
    font-size: 30px;
    font-family: Work Sans-Regular, Work Sans;
  }

  .pay-price {
    font-size: 54px;
    font-family: Work Sans-Bold, Work Sans;
    font-weight: bold;
    padding: 0 10px;
  }
}

.pay-h1 {
  font-size: 32px;
  font-family: Work Sans-Bold, Work Sans;
  font-weight: bold;
  color: #333333;
  padding: 40px 40px 20px 40px;
}
</style>
